import React, { useState, useRef } from 'react';
import {Link} from 'react-router-dom';
import MLB from '../svgs/ml-black';
import IM from '../svgs/im';
import Menu from '../svgs/menu';
import Close from '../svgs/close';
import CircleArrow from '../svgs/circle-arrow';
import CircleArrowBlack from '../svgs/circle-arrow-black';
import '../styles/sections/header.scss';

const services = require('../jsons/navigations/services-list.json');
const bottomLinks = require('../jsons/navigations/bottom-links.json');

function Header() {
    const [ openMenu, openMenuState ] = useState('');
    const body = document.body;
    const header = useRef(null);    

    const toggleMenu = () => {
        openMenuState(openMenu === "" ? "active" : "");
        if(openMenu === ""){
            header.current.classList.add('active')
            body.classList.add('menu-active')
        }else{
            header.current.classList.remove('active');
            body.classList.remove('menu-active');
        }
    }

    window.addEventListener('scroll', function(){
        var scrollPos = window.pageYOffset;
        var head = header.current;
        if(scrollPos > head.offsetHeight){
            head.classList.add('header-bg');
        }else{
            head.classList.remove('header-bg');
        }
    });   

    return (
        <header ref={header}>
            <div className="headerInner cf tal">
                <span                     
                    className="ham"
                    aria-label="Open the menu"
                    onClick={() => toggleMenu()}
                    >
                        { openMenu === 'active'
                            ? <Close />
                            : <Menu />
                        }
                </span>
                <h1 className="logo">                   
                    <Link to="/">
                        <span className="desktop-only"><MLB /></span>
                        <span className="mobile-only"><IM /></span>
                    </Link>                       
                </h1>
                <Link 
                    to="/get-quote"
                    className={`headerLink fr desktop-only line-anim`} 
                    onClick={() => toggleMenu()}
                    >
                    <CircleArrow />  
                    <CircleArrowBlack />  
                    <p><span>LET’S WORK</span><br /><span>TOGETHER</span></p>  
                </Link>                
            </div>            
            <div className={`fullMenu ${openMenu}`}>
                <div className="menuBody">
                    <div className="leftMenu">
                        <ul>
                            {services.map((link, index) =>
                                <li key={index} onClick={() => toggleMenu()}>
                                    <Link to={link.url} className="primary" data-title-hover={link.title}>
                                        {link.title}
                                    </Link>
                                </li>
                            )}                            
                        </ul>
                        <div>
                            {bottomLinks.map((link, index) =>
                                <p key={index} onClick={() => toggleMenu()}>
                                    <Link to={link.url} className="primary" data-title-hover={link.title}>
                                        {link.title}
                                    </Link>  
                                    <span>|</span>
                                </p>                              
                            )}                            
                        </div>
                    </div>                
                    <div className="rightMenu">
                        <h3>Say Hello!</h3>
                        <ul>
                            <li>
                                <h6>New York</h6>
                                <p><span>401 Park Avenue South, Suite 928, <br/>New York, NY 10016 <br/></span><a href="tel:+1 646-880-4504">+1 646-880-4504</a></p>
                            </li>
                            <li>
                                <h6>LOS ANGELES </h6>
                                <p><span>12575 Beatrice St. <br/>Los Angeles, CA 90066 <br/></span><a href="tel:+1 646-880-4504">+1 646-880-4504</a></p>
                            </li>
                            <li>
                                <h6>INDIA</h6>
                                <p><span>Plot 354, 100 Feet Rd, Ghitorni, <br/>New Delhi, India 110030 <br/></span><a href="tel:+1 646-880-4504">+91 981-048-8883</a></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="menuRect">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </header>
    );
}   

export default Header;